



























































import { Component, Vue, Emit, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";
import { vuex } from "@/store";
import rest from "@/rest";
import { signalrEventBus } from "@/main";

// components
import ExpandableCard from "../Shared/ExpandableCard.vue";
import MarkdownEditor from "../Shared/MarkdownEditor.vue";

// interfaces
import { ExerciseVM } from "@/interfaces/ExerciseVM";
import { CourseElementVm } from "@/interfaces/CourseElementVm";
import { CourseElementType } from '@/interfaces/CourseElementType';
import { courseElementTypeItems } from "@/interfaces/Types";
import { ParamDictionary } from "@/interfaces/ParamDictionary";
import { ExBundleVM } from "@/interfaces/ExBundleVM";
import { CustomizationVm } from "@/interfaces/CustomizationVm";

const globals = namespace("globals");
const customization = namespace("customization");

@Component({
  components: {
    ExpandableCard,
    MarkdownEditor
  },
})
export default class PdfElementSettings extends Vue {
  // @Prop() element!: CourseElementVm;
  @globals.Getter selectedBundle!: ExBundleVM | null;
  @globals.Getter selectedExercise!: ExerciseVM;
  @globals.Getter selectedElement!: CourseElementVm | null;
  @globals.Action refreshSelectedElement!: () => Promise<void>;
  @customization.Getter customizationSettings!: CustomizationVm;

  courseElementTypeItems = courseElementTypeItems;

  isBusy = false;
  showMarkdownEditor = false;
  selectedLanguageCode = "de-DE";
  id = "";

  mounted() {}

  created() {
    // SignalR event listener
    signalrEventBus.$on('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  beforeDestroy() {
    // clearAllBodyScrollLocks();
    // Make sure to cleanup SignalR event handlers when removing the component
    signalrEventBus.$off('backgroundTaskEvent', this.backgroundTaskEvent);
  }

  // SignalR events
  async backgroundTaskEvent(response: { id: string, progress: number, message: string, status: string }) {
    console.log("PdfElementSettings > Background task event:", response);
    if (this.id !== response.id) return;

    if (response.status == "INF") {
      vuex.ux.SB_SUCCESS({
        message: response.message,
        timeout: 1500
      });
      return;
    }

    // Reload the element to get the updated AI summary
    await this.refreshSelectedElement();
    // Update MediaPool
    this.$root.$emit('fileListUpdate:MediaPool'); // notify media pool via global event to refresh file list

    this.isBusy = false;
  }

  async onCreateAiSummary(): Promise<void> {
    if (!this.selectedElement || !this.selectedBundle) return;

    await this.$l3rnOnlineHub.ensureConnection();
    this.isBusy = true;

    let params: ParamDictionary = { dictionary: {}};
    params.dictionary!["SignalRId"] = this.$l3rnOnlineHub.ConnectionId!;
    params.dictionary!["BundleId"] = this.selectedBundle.id.toString();
    params.dictionary!["FileName"] = this.$globalHelper.extractFileName(this.selectedElement.contentUrl ?? "");
    params.dictionary!["LanguageCode"] = this.selectedLanguageCode || "de-DE";

    await rest.url("contentManager/createAiSummary").post(params)
      .then(async (response) => {
        console.log("PdfElementSettings > Create AI Summary response:", response);
        if (!response || !this.selectedElement || !this.selectedBundle) return;
        this.id = response;
      })
      .catch(err => {
      })
  }

  getElementTitle(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.label : '';
  }

  getElementIcon(type: string | null): string {
    const element = this.courseElementTypeItems.find(el => CourseElementType[el.value] === type);
    return element ? element.icon : '';
  }

  // private async convertPdfToText(): Promise<void> {
  //   if (!this.selectedElement) return;
  //   let params: ParamDictionary = { dictionary: {}};
  //   params.dictionary!["BundleId"] = this.selectedExercise.exBundleId!.toString();
  //   params.dictionary!["ExerciseId"] = this.selectedExercise.id!.toString();
  //   params.dictionary!["FilePath"] = this.selectedElement.contentUrl!;

  //   rest.url("contentManager/convertPdfToText").post(params)
  //     .then((response) => {
  //       console.log("response", response);
  //     })
  //     .catch(err => {
  //     });
  // }
}
